import axios from "axios";

export const GetSalePersonList = async (params) => {
    let data =  {
        StartDate : params.startDate,
        EndDate : params.endDate,
        Operator : params.operator,
        ProductType : params.productType,
        CompanyId : params.companyId,
        UserId : params.userId,
        RoleName: params.roleName,
    }
    
    let response;
    try{
        response = await axios.post(`/api/SalePerson/GetSalePersonList`,data);
        if(response && response.status === 200){
            return response.data.records;
        }else{
            return response.status;
        }

    }catch(error){
        if (error.response && error.response.status === 401) {
            return error.response.status;
        }
        return [];
    }
}